<template>
  <div>
    <Header></Header>
    <section class="top">

    </section>
    <el-container class='middle'>
      <!-- 列表 -->
      <el-aside width="25%">
        <div class="Tabul">产品分类</div>
        <div class="menu-top" :class="classify==1?'menu-tops':''"  @click="Handover(1)"><img src="../../static/img/dajiao.gif"  alt="">工业物联</div>
        <div class="menu-list">
          <div class="menu-list-tob" v-for="(item,i) in Tabledata.Industrial" @click="goProduct(item.id)"><img src="../../static/img/xiaojiao.gif" alt="">{{item.title}}</div>
        </div>
        <div class="menu-top" :class="classify==2?'menu-tops':''" @click="Handover(2)"><img src="../../static/img/dajiao.gif" alt=""  >智慧水务</div>
        <div class="menu-list">
          <div class="menu-list-tob" v-for="(item,i) in Tabledata.dieslab" @click="goProduct(item.id)"><img src="../../static/img/xiaojiao.gif" alt="">{{item.title}}</div>
        </div>
      </el-aside>
      <!-- 产品 -->
      <el-main>
        <el-row>
          <el-col :span="8" v-for="(item,i) in Realdata" :key='i' >
            <div class="Outer" @click="goProduct(item.id)">
              <div class="list-img">
                <img :src="item.url" alt="">
              </div>
              <div class="list-title">
                {{item.title}}
              </div>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
    <Footer></Footer>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        btnCor: 0,
        // 渲染数据
        Realdata:[],
        // 全部数据
        listdata:[],
        // 左侧栏数据
        Tabledata:{
          Industrial:[],//工业物联
          dieslab:[],//智慧水务
        },
        // 分类
        classify:0
      }
    },
    mounted() {
      // 获取返回参数
      this.listdata = this.template
      console.log(this.$route);
      if(this.$route.query.tid!=undefined){
        this.Handover(this.$route.query.tid)
      }
      // 数据赋值
      this.Realdata = this.listdata
      for (var i = 0; i < this.listdata.length; i++) {
        if(this.listdata[i].type==1){
          this.Tabledata.Industrial.push(this.listdata[i])
        }else if(this.listdata[i].type==2){
          this.Tabledata.dieslab.push(this.listdata[i])
        }
      }
    },
    methods: {
      // 切换分类
      Handover(type){
        this.classify = type
        if(type==1){
          this.Realdata = []
          for (var i = 0; i < this.listdata.length; i++) {
            if(this.listdata[i].type==type){
              this.Realdata.push(this.listdata[i])
            }
          }
        }else if(type==2){
          this.Realdata = []
          for (var i = 0; i < this.listdata.length; i++) {
            if(this.listdata[i].type==type){
              this.Realdata.push(this.listdata[i])
            }
          }
        }
      },
      // 跳转产品页
      goProduct(id){
          this.$router.push({ name: 'Product', query: { tid: id }})
      }
    }
  }
</script>

<style scoped lang="scss">


  .top {
    height: 460px;
    background-image: url(../../static/img/topbgimg3.png);
    background-repeat: no-repeat;
  }

  .middle {
    width: 94%;
    max-width: 1400px;
    min-width: 0px;
    height: auto;
    max-height: none;
    margin: 0 auto;

    .el-main {
      min-height: 700px;
      .el-row {
        .el-col {
          &:hover .Outer {
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            .list-img img {
              transform: scale(1.1);
            }
            .list-title::before {
              width: 100%;
            }
          }
          .Outer {
            cursor: pointer;
            border-radius: 8px;
            padding: 10px 0;
            border: 1px solid #eee;

            .list-img {
              height: 200px;
              text-align: center;
              margin-bottom: 10px;
              overflow: hidden;

              img {
                transition: 0.5s;
                width: 100%;
                height: 100%;
              }
            }

            .list-title {
              position: relative;
              padding: 5px 0px 0 0;
              border-top: 1px solid #eee;
              font-size: 18px;
              font-weight: bold;
              color: #333;
              text-align: center;
              line-height: 30px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              &::before {
                content: '';
                position: absolute;
                top: 0px;
                left: 0px;
                width: 0%;
                height: 1px;
                background: #232323;
                z-index: 1;
                transition: 1s;
              }

            }
          }
        }
      }
    }
  }

  .el-aside {
    padding: 20px;
    .Tabul {
      display: inline-block;
      // vertical-align: middle;
      line-height: 70px;
      color: rgba(255, 255, 255, 1);
      font-weight: normal;
      font-size: 30px;
      width: 100%;
      background-color: #226cb5;
      height: 70px;
      padding-left: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

    }
    .menu-top{
      &:hover{
        background: #00458e;
        color: #FFFFFF;
      }
      cursor: pointer;
      width: 100%;
      line-height: 40px;
      height: 40px;
      border-bottom: 1px solid #e8e8e8;
      font-size: 16px;
      img{
        margin: 0 12px;
        margin-top: -6px;
      }
    }
    .menu-tops{
      background: #00458e;
      color: #fff;
    }
    .menu-list{
      padding-left: 20px;
      .menu-list-tob{
        &:hover{
          background: #00458e;
          color: #FFFFFF;
        }
        cursor: pointer;
        width: 100%;
        line-height: 40px;
        height: 40px;
        border-bottom: 1px solid #e8e8e8;
        font-size: 14px;
        img{
          margin: 0 8px;
          margin-top: -4px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Electricity.vue